module.exports = __webpack_public_path__ + "media/react/schools/app/assets/rocket-e657f35fdb22db351eeb307997b5cf28.png";